function buildUserDataObject(json) {
  const object = {
    id: json.id,
    name: json.name,
    surname: json.surname,
    father: json.father,
    mother: json.mother,
    birthday: json.birthday,
    family_id: json.family_id,
    // family_head: json.family_head,
    family_head_link: json.family_head_link,
    cel: json.cel,
    rrogat: json.rrogat?.map(obj => buildRrogatObject(obj)) || null,
    plateArray: json.plateArray?.map(obj => buildPlateObject(obj)) || null,
  };
  return object;
}

function buildRrogatObject(jsonObject) {
  if (!jsonObject) {
    error(`buildRrogatObject, jsonObject: ${jsonObject}`);
    return null;
  }
  const object = {
    //array
    NID: jsonObject.NID,
    EMRI: jsonObject.EMRI,
    MBIEMRI: jsonObject.MBIEMRI,
    EMRI_PLOTE: jsonObject.EMRI_PLOTE,
    NIPT: jsonObject.NIPT,
    SUBJEKTI: jsonObject.SUBJEKTI,
    DRT: jsonObject.DRT,
    PAGA_BRUTO: jsonObject.PAGA_BRUTO,
    PROFESIONI: jsonObject.PROFESIONI,
    KATEGORIA: jsonObject.KATEGORIA,
    TYPE: jsonObject.TYPE,
  };
  return object;
}

function buildPlateObject(jsonObject) {
  if (!jsonObject) {
    error(`buildPlateObject, jsonObject: ${jsonObject}`);
    return null;
  }
  const object = {
    //array
    NID: jsonObject.NID,
    EMRI: jsonObject.EMRI,
    MBIEMRI: jsonObject.MBIEMRI,
    PLATE: jsonObject.PLATE,
    MAKE: jsonObject.MAKE,
    MODEL: jsonObject.MODEL,
    COLOR: jsonObject.COLOR,
  };
  return object;
}

function buildCelObject(jsonObject) {
  if (!jsonObject) {
    error(`buildCelObject, jsonObject: ${jsonObject}`);
    return null;
  }
  const object = {
    //array
    NID: jsonObject.NID,
    EMRI: jsonObject.EMRI,
    MBIEMRI: jsonObject.MBIEMRI,
    ATESIA: jsonObject.ATESIA,
    EMRI_PLOTE: jsonObject.EMRI_PLOTE,
    DATELINDJA: jsonObject.DATELINDJA,
    TEL: jsonObject.TEL,
  };
  return object;
}

function buildValueSasiaObject(jsonObject) {
  if (!jsonObject) {
    error(`buildValueSasiaObject, jsonObject: ${jsonObject}`);
    return null;
  }
  const object = {
    //array
    EMRI: jsonObject.name,
    SASIA: jsonObject.name_count,
  };
  return object;
}

function buildErrorObject(jsonObject) {
  const object = {
    statusCode: jsonObject.statusCode,
    body: jsonObject.body,
    message: jsonObject.message,
  };

  return object;
}

function error(message) {
  console.error(message);
}

export {
  buildUserDataObject,
  buildRrogatObject,
  buildPlateObject,
  buildCelObject,
  buildValueSasiaObject,
  buildErrorObject,
};
